// extracted by mini-css-extract-plugin
export default {"myprofile":"Profile_myprofile__+drzT","table":"Profile_table__LmVxQ"};